import * as React from 'react';
import { classes } from '../Pagination.st.css';
import { DataHooks, HelperIds } from '../constants';
import { getId } from '../utils';
export const PageCompact = ({ currentPage, slashLabel, totalPages, }) => {
    return (React.createElement("div", { "data-hook": DataHooks.pageCompact, className: classes.compact },
        React.createElement("span", { id: getId(HelperIds.pageCompact) },
            currentPage,
            " ",
            slashLabel,
            " ",
            totalPages)));
};
//# sourceMappingURL=PageCompact.js.map